import { actionTypes } from 'actions/actionTypes'
import type { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const clearPayPalClientToken: CheckoutActionCreator = () => ({
  type: actionTypes.PAYMENT_SET_PAYPAL_CLIENT_TOKEN,
  token: null,
})
